var map = {
	"./BIODIVERSITY_PRESERVATION.svg": 4239,
	"./BLUE_HIGH.svg": 2369,
	"./BLUE_LOW.svg": 2496,
	"./BLUE_MEDIUM.svg": 6578,
	"./BLUE_VERY_HIGH.svg": 7017,
	"./BLUE_VERY_LOW.svg": 8358,
	"./CHEMICALS_RESTRICTED_BY_CONVENTIONS.svg": 9100,
	"./CLIMATE_CHANGE_ADAPTATION.svg": 9346,
	"./CLIMATE_CHANGE_MITIGATION.svg": 9326,
	"./EDUCATION.svg": 9376,
	"./ELECTRICITY.svg": 1151,
	"./Excel-logo.svg": 8717,
	"./FINANCIAL_ACCESSIBILITY.svg": 1450,
	"./FOOD_SECURITY.svg": 3083,
	"./FOSSIL_FUELS.svg": 4170,
	"./GAMBLING.svg": 573,
	"./Greeneye-logo-new.svg": 4658,
	"./Greeneye-logo-old.svg": 2449,
	"./Greeneye-logo.svg": 3358,
	"./HANDHEL_WEAPONS.svg": 2711,
	"./HEALTH.svg": 445,
	"./HIGH.svg": 6266,
	"./INDISCRIMINATE_WEAPONS.svg": 3940,
	"./LOW.svg": 2989,
	"./MEDICAL_PRODUCTS_TESTED_ON_ANIMALS.svg": 3205,
	"./MEDIUM.svg": 3897,
	"./NATURAL_RESOURCE_MINING.svg": 2198,
	"./NON_MEDICAL_PRODUCTS_TESTED_ON_ANIMALS.svg": 6840,
	"./NUCLEAR_ENERGY_INVOLVEMENT.svg": 1017,
	"./NUCLEAR_WEAPON_INVOLVEMENT.svg": 6004,
	"./PESTICIDES.svg": 9018,
	"./POLLUTION_REDUCTION.svg": 8866,
	"./PORNOGRAPHY.svg": 4456,
	"./PUBLIC_TRANSPORT.svg": 5933,
	"./RED_HIGH.svg": 1842,
	"./RED_LOW.svg": 4597,
	"./RED_MEDIUM.svg": 2343,
	"./RED_VERY_HIGH.svg": 3148,
	"./RED_VERY_LOW.svg": 6870,
	"./RENEWABLE_ENERGY.svg": 5417,
	"./SAFETY.svg": 6036,
	"./SECURITY_SYSTEMS.svg": 1752,
	"./TELECOMMUNICATIONS.svg": 2094,
	"./TOBACCO.svg": 7202,
	"./WATER_AND_SANITATION.svg": 7337,
	"./default_negative.svg": 1181,
	"./default_sdg.svg": 4944,
	"./flag.svg": 5165,
	"./flag_white.svg": 8094,
	"./greeneyeG.svg": 5864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;